import { ILicenseOrder, LicenseOrder } from "./LicenseOrder";

export enum LicenseType { Individual, Group, Master, Instructor, Subscription, AccessGranted }
export enum LicenseStatus { None, Reserved, Canceled };
export enum LicenseErrorCode {
    None = 0,
    InvalidCustomerId = 100,
    InvalidTransactionId = 101,
    InvalidProductId = 102,
    InvalidBillingGroupId = 103,
    InvalidActivationCode = 106,
    Unauthorized = 108,
    InvalidLicenseOrder = 109,
    InvalidLicense = 110,
    LicenseNotCancelable = 200,
    LicenseCancelationExists = 201,
    LicenseNotFound = 202,
    InternalSystemError = 900,
    SystemTimeout = 901
}

export class License extends LicenseOrder implements ILicense {
    constructor(license?: ILicense) {
        super(license);
        if (license) {
            this.licenseTypeCode = license.licenseTypeCode;
            if (license.licenseType != null)
                this.licenseType = license.licenseType;
            this.licenseId = license.licenseId;
            this.licenseIndex = license.licenseIndex;
            this.licenseCount = license.licenseCount;
            this.activationCode = license.activationCode;
            this.courseIds = license.courseIds;
            this.expirationDate = license.expirationDate;
            this.durationMonths = license.durationMonths;
            this.isEntityRequired = license.isEntityRequired;
            this.entityId = license.entityId;
            this.description = license.description;
            this.accessUrl = license.accessUrl;
            this.statusCode = license.statusCode;
            if (license.licenseStatus != null)
                this.licenseStatus = license.licenseStatus;
            this.statusDate = license.statusDate;
        }
    }

    licenseTypeCode: string;
    licenseType: LicenseType = LicenseType.Individual;
    licenseId: number;
    licenseIndex: number = 0;
    licenseCount: number = 0;
    activationCode: string;
    activationCodes: string[];
    courseIds: string;
    expirationDate?: string;
    durationMonths?: number;
    isEntityRequired: boolean;
    entityId?: string;
    description: string;
    accessUrl: string;
    statusCode: string;
    licenseStatus: LicenseStatus = LicenseStatus.None;
    statusDate: string;
}

export interface ILicense extends ILicenseOrder {
    licenseTypeCode: string;
    licenseType: LicenseType;
    licenseId: number;
    licenseIndex: number;
    licenseCount: number;
    activationCode: string;
    activationCodes: string[];
    courseIds: string;
    expirationDate?: string;
    durationMonths?: number;
    isEntityRequired: boolean;
    entityId?: string;
    description: string;
    accessUrl: string;
    statusCode: string;
    licenseStatus: LicenseStatus;
    statusDate: string;
}